<div class="generic-document-capture-container">
  @if (document?.isSubmitted !== true) {
    <app-drag-and-drop
      [allowMultipleFiles]="allowMultipleFiles"
      [enableUploadButton]="isUploadButtonEnabled"
      [fileTitle]="fileTitle"
      (onFileUploaded)="onUploadDocument($event)"
      (onClean)="onCleanDocument($event)"
    ></app-drag-and-drop>
    @if (displayInstructions) {
      <div id="instruction-container">
        <strong>Just make sure</strong><br />
        <ul>
          @for (instruction of displayInstructions; track instruction) {
            <li
              [innerHTML]="instruction"
            ></li>
          }
          <br />
        </ul>
      </div>
    }
  }
  <app-document-capture-footer
    [isSubmitted]="document?.isSubmitted || false"
    [enableSubmitButton]="isSubmitButtonEnabled"
    (submitClicked)="onSubmit($event)"
  ></app-document-capture-footer>
</div>
